import React from 'react'
import { intl } from 'lang/intl'

import { WebinarPanelComponent } from '../../../WebinarSidebarFeature/components'
import type { PollUnitWrapperProps } from '../../../../../Polls/model/Poll'

export const renderPollUnitWrapper = (pollProps: PollUnitWrapperProps) => (
  <WebinarPanelComponent
    {...pollProps}
    title={pollProps.title && intl.formatMessage({ defaultMessage: 'Poll' })}
  />
)
